"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const icons_1 = require("./icons");
require("./styles.css");
const Tag = props => {
    const { content, onRemove } = props;
    const renderButton = () => {
        return onRemove ? (react_1.default.createElement("img", { src: icons_1.deleteIcon, onClick: onRemove, className: "full-height" })) : null;
    };
    return (react_1.default.createElement("div", { className: "flex-container map-tag" },
        react_1.default.createElement("h5", { className: "full-height no-margin text" }, content),
        renderButton()));
};
exports.default = Tag;
